export type ServiceName = 'pam' | 'ntl' | 'sqw' | 'cml' | 'nrc' | 'neo' | 'ntl-ssr' | 'cml-ssr' | 'scr'

export class TimeoutError extends Error {
    constructor(message = 'Request timeout') {
        super(message)
        this.name = 'TimeoutError'
    }
}
